import AuthService from "./api/AuthService"

export const getProfileData = async (payload) => {
    try {
        const response = await AuthService.get(`/users/${payload}/profile?include=avatar,sessions,contacts,inscriptions,overall_progress,enrollments,academic_performance`)
        return response.data
    } catch {
        throw new Error("Ocorreu um erro ao requisitar dados do perfil! Tente novamente")
    }
}

export const uploadProfilePhoto = async (payload) => {
    try {
        const formData = new FormData()
        formData.append('photo', payload.photo)

        const response = await AuthService.post(`/users/${payload.userId}/photo`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })
        return response.data
    } catch {
        throw new Error("Ocorreu um erro ao atualizar a foto de perfil! Tente novamente")
    }
}

export const getProfileLogs = async (payload) => {
    try {
        let url = `/logs/student?users_ids[]=${payload.userId}&per_page=${payload.perPage || 10}&page=${payload.page || 1}`

        if (typeof payload.search === 'string' && payload.search.trim() !== '') {
            url += `&search=${encodeURIComponent(payload.search.trim())}`
        }

        if (typeof payload.startDate === 'string' && payload.startDate.trim() !== '') {
            url += `&start_date_time=${encodeURIComponent(payload.startDate.trim())}`
        }

        if (typeof payload.endDate === 'string' && payload.endDate.trim() !== '') {
            url += `&end_date_time=${encodeURIComponent(payload.endDate.trim())}`
        }

        const response = await AuthService.get(url)
        return response.data
    } catch {
        throw new Error("Ocorreu um erro ao requisitar registros de atividades! Tente novamente")
    }
}

export const getProfileLogsCSV = async (userId) => {
    try {
        const response = await AuthService.get(`/logs/students/${userId}/csv`)
        return response.data
    } catch {
        throw new Error("Ocorreu um erro ao baixar registros de atividades! Tente novamente")
    }
}

export const getProfileFollowers = async (payload) => {
    try {
        const response = await AuthService.get(`/users/${payload}/followers`)
        return response.data
    } catch {
        throw new Error("Ocorreu um Erro ao requisitar seguidores! Tente novamente")
    }
}

export const getProfileFollowing = async (payload) => {
    try {
        const response = await AuthService.get(`/users/${payload}/following `)
        return response.data
    } catch {
        throw new Error("Ocorreu um Erro ao requisitar seguidores! Tente novamente")
    }
}

export const updateFollowUserState = async (profileId) => {
    try {
        const response = await AuthService.post(`/users/${profileId}/follow`)
        return response.data
    } catch (error) {
        throw new Error("Ocorreu um erro ao atualizar o estado se seguidor! Tente novamente")
    }
}